module.exports = __webpack_public_path__ + "img/cdn.3d9b7e8.svg";